define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('div', {
            'className': this.getClass(),
            'onClick': this.props.onClick
        }, this.getChildren());
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-row/table-row.rt
 ** module id = 204
 ** module chunks = 0
 **/